import React from 'react';
import { Shield, Eye, Lock, Heart } from 'lucide-react';
import { privacyPoints } from '../data/mock';

const icons = [Shield, Eye, Lock, Heart];

export const Privacy = () => {
  return (
    <section id="safety" className="py-24 bg-gradient-to-br from-slate-900 via-gray-900 to-slate-800 text-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-block mb-6">
              <div className="w-20 h-20 bg-teal-500/20 rounded-2xl flex items-center justify-center mx-auto backdrop-blur-sm">
                <Shield className="h-10 w-10 text-teal-400" />
              </div>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Privacy-first proximity.
              <br />
              <span className="text-teal-400">Always.</span>
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed">
              Your location, your control. We built Fuzz with trust and comfort at the core — not surveillance.
            </p>
          </div>

          {/* Privacy Points */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {privacyPoints.map((point, index) => {
              const Icon = icons[index];
              return (
                <div 
                  key={index} 
                  className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-2xl hover:bg-white/10 transition-all"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-teal-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Icon className="h-6 w-6 text-teal-400" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-1">{point}</h3>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Additional Info */}
          <div className="bg-teal-500/10 backdrop-blur-sm border border-teal-500/20 p-8 rounded-2xl">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                <Heart className="h-6 w-6 text-teal-400" />
              </div>
              <div>
                <h3 className="text-xl font-bold mb-3">Built with care, not creepiness</h3>
                <p className="text-gray-300 leading-relaxed">
                  We understand that location sharing can feel invasive. That's why Fuzz gives you complete control over who sees you, when they see you, and how they can interact with you. Your privacy is not just a feature — it's our foundation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
